/* Imports */
import React from "react"
import { Table } from "fajny-react"
import { Link } from "react-router-dom"

import ComponentPage from "../../components/ComponentPage"

import commonProps from "../../data/common-props"

const TablePage = () => {
    const items = [
        {
            title: "Bordered",
            content: (
                <Table tableStyle="bordered">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Facebook</th>
                            <th>Twitter</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td>1</td>
                            <td>
                                <Link to="#">Anna</Link>
                            </td>
                            <td>Fali</td>
                            <td>Anna Fali</td>
                            <td>@anna.fali</td>
                        </tr>

                        <tr>
                            <td>2</td>
                            <td>
                                <Link to="#">Niek</Link>
                            </td>
                            <td>Bove</td>
                            <td>Niek Bove</td>
                            <td>@niek.bove</td>
                        </tr>

                        <tr>
                            <td>3</td>
                            <td>
                                <Link to="#">Lacara</Link>
                            </td>
                            <td>Jones</td>
                            <td>Lacara Jones</td>
                            <td>@lacara.jones</td>
                        </tr>

                        <tr>
                            <td>4</td>
                            <td>
                                <Link to="#">Pablo</Link>
                            </td>
                            <td>Cambeiro</td>
                            <td>Pablo Cambeiro</td>
                            <td>@pablo.cambeiro</td>
                        </tr>

                        <tr>
                            <td>5</td>
                            <td>
                                <Link to="#">Irene</Link>
                            </td>
                            <td>Sotelo</td>
                            <td>Irene Sotelo</td>
                            <td>@irene.sotelo</td>
                        </tr>
                    </tbody>
                </Table>
            ),
            code: '<Table tableStyle="bordered">\n    <thead>\n        <tr>\n            <th>#</th>\n            <th>First Name</th>\n            <th>Last Name</th>\n            <th>Facebook</th>\n            <th>Twitter</th>\n        </tr>\n    </thead>\n\n    <tbody>\n        <tr>\n            <td>1</td>\n            <td>\n                <Link to="#">Anna</Link>\n            </td>\n            <td>Fali</td>\n            <td>Anna Fali</td>\n            <td>@anna.fali</td>\n        </tr>\n    </tbody>\n</Table>',
        },
        {
            title: "Stripped",
            content: (
                <Table tableStyle="stripped">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Facebook</th>
                            <th>Twitter</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td>1</td>
                            <td>
                                <Link to="#">Anna</Link>
                            </td>
                            <td>Fali</td>
                            <td>Anna Fali</td>
                            <td>@anna.fali</td>
                        </tr>

                        <tr>
                            <td>2</td>
                            <td>
                                <Link to="#">Niek</Link>
                            </td>
                            <td>Bove</td>
                            <td>Niek Bove</td>
                            <td>@niek.bove</td>
                        </tr>

                        <tr>
                            <td>3</td>
                            <td>
                                <Link to="#">Lacara</Link>
                            </td>
                            <td>Jones</td>
                            <td>Lacara Jones</td>
                            <td>@lacara.jones</td>
                        </tr>

                        <tr>
                            <td>4</td>
                            <td>
                                <Link to="#">Pablo</Link>
                            </td>
                            <td>Cambeiro</td>
                            <td>Pablo Cambeiro</td>
                            <td>@pablo.cambeiro</td>
                        </tr>

                        <tr>
                            <td>5</td>
                            <td>
                                <Link to="#">Irene</Link>
                            </td>
                            <td>Sotelo</td>
                            <td>Irene Sotelo</td>
                            <td>@irene.sotelo</td>
                        </tr>
                    </tbody>
                </Table>
            ),
            code: '<Table tableStyle="stripped">\n    <thead>\n        <tr>\n            <th>#</th>\n            <th>First Name</th>\n            <th>Last Name</th>\n            <th>Facebook</th>\n            <th>Twitter</th>\n        </tr>\n    </thead>\n\n    <tbody>\n        <tr>\n            <td>1</td>\n            <td>\n                <Link to="#">Anna</Link>\n            </td>\n            <td>Fali</td>\n            <td>Anna Fali</td>\n            <td>@anna.fali</td>\n        </tr>\n    </tbody>\n</Table>',
        },
    ]
    
    const propsItems = [
        {
            name: "tableStyle",
            type: "String",
            example: "stripped",
            possible: '"bordered" | "stripped"',
            default: "bordered",
        },
        {
            name: "textAlign",
            type: "String",
            example: "center",
            possible: commonProps.textAlign,
            default: "left",
        },
        {
            name: "vAlign",
            type: "String",
            example: "middle",
            possible: '"baseline" | "top" | "middle" | "bottom" | "sub" | "text-top"',
            default: "baseline",
        },
    ]

    return <ComponentPage items={items} propsItems={propsItems} />
}

export default TablePage
